import * as Sentry from '@sentry/react'

import { AdminRole } from '@/out/admin'
import { bootstrapAdmin } from '@/thunks/admins/bootstrap'
import { signOut } from '@/thunks/authentications/sign-out'

import { CaseReducer, createSlice, PayloadAction } from '@reduxjs/toolkit'

type AuthState = {
  token: string | undefined
  role?: AdminRole
  isRoot?: true
  email?: string
  hasOnboarded?: boolean
}

const initialState: AuthState = {
  token: localStorage.getItem('token') as string,
}

const setJWT: CaseReducer<AuthState, PayloadAction<string>> = (_, action) => {
  localStorage.setItem('token', action.payload)
  return {
    token: action.payload,
  }
}

const setAuth: CaseReducer<AuthState, PayloadAction<{ token: string; role: AdminRole }>> = (_, action) => {
  localStorage.setItem('token', action.payload.token)
  return {
    token: action.payload.token,
    role: action.payload.role,
  }
}

const clearJWT: CaseReducer<AuthState> = () => {
  localStorage.removeItem('token')
  Sentry.setUser(null)
  return {
    token: undefined,
  }
}

const setHasOnboarded: CaseReducer<AuthState, PayloadAction<boolean>> = (state, action) => {
  state.hasOnboarded = action.payload
  return state
}

const slice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setJWT,
    setAuth,
    clearJWT,
    setHasOnboarded,
  },
  extraReducers: builder => {
    builder.addCase(bootstrapAdmin.fulfilled, (state, action) => {
      const { data } = action.payload

      Sentry.setUser({
        id: data.id,
        accountId: data.account.id,
        firstName: data.firstName,
        lastName: data.lastName,
        email: data.email,
      })

      if ('isRoot' in data && data.isRoot) {
        state.isRoot = true
      }

      state.role = data.role
      state.email = data.email
      state.hasOnboarded = data.account.hasOnboarded
      return state
    })

    builder.addCase(signOut.fulfilled, () => {
      return { token: undefined }
    })
  },
})

export default slice

export const actions = slice.actions
